import { render } from "./TeamCard.vue?vue&type=template&id=6c50934c&scoped=true"
import script from "./TeamCard.vue?vue&type=script&lang=js"
export * from "./TeamCard.vue?vue&type=script&lang=js"

import "./TeamCard.vue?vue&type=style&index=0&id=6c50934c&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c50934c"]])

export default __exports__